/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["[_nghost-%COMP%]{max-width:680px;min-width:480px}header[_ngcontent-%COMP%]{display:flex;justify-content:space-between;align-items:center}.title[_ngcontent-%COMP%]{font-family:\"PT Sans\",sans-serif;font-size:28px;font-weight:400;text-align:left;margin:0}svg-icon[_ngcontent-%COMP%]{color:#636f79}svg-icon.close[_ngcontent-%COMP%]{width:20px;height:20px}.details[_ngcontent-%COMP%]{margin-top:32px}.details-title[_ngcontent-%COMP%]{color:#424650;font-size:14px;font-weight:700}.details-row[_ngcontent-%COMP%]{display:flex;margin-top:16px}"];
export { styles as styles };
